import {Injectable} from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class SecurityModelHistoryGridLayoutService {

    constructor() {
    }

    getFrameworkComponents() {
        return {};
    }

    getSecColumnDefs() {
        return [
            {
                headerName: "Timestamp",
                field: "createdDate",
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm a', displayETtext: true},
                minWidth: 150,
                suppressMovable: true,
                sort: 'desc'
            },
            {
                headerName: "User",
                field: "modifiedBy",
                minWidth: 70,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: true
            },
            {
                headerName: "Symbol",
                field: "securitySymbol",
                minWidth: 50,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: true
            },
            {
                headerName: "Description",
                field: "securityDescription",
                minWidth: 100,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: true
            },
            {
                headerName: "Attribute",
                field: "attribute",
                minWidth: 50,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: true
            },
            {
                headerName: "Previous Value",
                field: "previousValue",
                suppressMovable: true,
                valueFormatter: (params: any) => (params.value && params.value.toLowerCase() === "none") ? "-" : params.value
            },
            {
                headerName: "Updated Value",
                field: "updatedValue",
                suppressMovable: true,
                valueFormatter: (params: any) => (params.value && params.value.toLowerCase() === "none") ? "-" : params.value
            }
        ];
    }

    getBlendedHistoryColumnDefs() {
        return [
            {
                headerName: "Timestamp",
                field: "createdDate",
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm a', displayETtext: true},
                minWidth: 150,
                suppressMovable: true,
                sort: 'desc'
            },
            {
                headerName: "User",
                field: "modifiedBy",
                minWidth: 70,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: true
            },
            {
                headerName: "Model Name",
                field: "modelName",
                minWidth: 50,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: true
            },
            {
                headerName: "Description",
                field: "modelDesc",
                minWidth: 100,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: true
            },
            {
                headerName: "Attribute",
                field: "attribute",
                minWidth: 50,
                cellRenderer: 'cellRendererFormatter',
                suppressMovable: true
            },
            {
                headerName: "Previous Value",
                field: "previousValue",
                suppressMovable: true,
                valueFormatter: (params: any) => (params.value && params.value.toLowerCase() === "none") ? "-" : params.value
            },
            {
                headerName: "Updated Value",
                field: "updatedValue",
                suppressMovable: true,
                valueFormatter: (params: any) => (params.value && params.value.toLowerCase() === "none") ? "-" : params.value
            }
        ];
    }
}
 


